var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class UploadConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "CsvSchemaVersion");
    /**
     */
    __publicField(this, "SchemaVersion");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof UploadConfiguration
     */
    __publicField(this, "$type", "V1.Cesop.Periods.UploadConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CsvSchemaVersion = UploadConfigurationCsvSchemaVersion[_data["CsvSchemaVersion"]];
      this.SchemaVersion = UploadConfigurationSchemaVersion[_data["SchemaVersion"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CsvSchemaVersion"] = UploadConfigurationCsvSchemaVersion[this.CsvSchemaVersion];
    _data["SchemaVersion"] = UploadConfigurationSchemaVersion[this.SchemaVersion];
    return _data;
  }
}
export var UploadConfigurationCsvSchemaVersion = /* @__PURE__ */ ((UploadConfigurationCsvSchemaVersion2) => {
  UploadConfigurationCsvSchemaVersion2["V4_8"] = "V4_8";
  UploadConfigurationCsvSchemaVersion2["V5_0"] = "V5_0";
  return UploadConfigurationCsvSchemaVersion2;
})(UploadConfigurationCsvSchemaVersion || {});
export var UploadConfigurationSchemaVersion = /* @__PURE__ */ ((UploadConfigurationSchemaVersion2) => {
  UploadConfigurationSchemaVersion2["V4_8"] = "V4_8";
  UploadConfigurationSchemaVersion2["V5_0"] = "V5_0";
  return UploadConfigurationSchemaVersion2;
})(UploadConfigurationSchemaVersion || {});
